import React from 'react';
import { Button, DatePicker, Flex } from 'antd';
import { mdiCalendarMonth } from '@mdi/js';
import Icon from '@mdi/react';
import dayjs from 'dayjs';

const { RangePicker: AntdRangePicker } = DatePicker;

const RangePicker = ({ date = {}, showExpandDays = true, datePickerProps = {}, onChange }) => {
  const value = [
    date?.date_from ? dayjs(date.date_from) : null,
    date?.date_to ? dayjs(date.date_to) : null,
  ];

  const adjustDateRange = (type) => {
    const [from, to] = value;
    if (!from || !to) return;

    const newFrom = type === 'add' ? from : from.subtract(10, 'day');
    const newTo = type === 'add' ? to.add(10, 'day') : to;

    onChange?.({
      date_from: newFrom.format('YYYY-MM-DD'),
      date_to: newTo.format('YYYY-MM-DD'),
    });
  };

  const handleChange = (dates) => {
    if (dates && dates[0] && dates[1]) {
      onChange?.({
        date_from: dates[0].format('YYYY-MM-DD'),
        date_to: dates[1].format('YYYY-MM-DD'),
      });
    } else {
      onChange?.({ date_from: null, date_to: null });
    }
  };

  return (
    <Flex align='center' gap='small' className='sm:flex-nowrap flex-wrap'>
      {showExpandDays && (
        <Button size='middle' shape='round' onClick={() => adjustDateRange('subtract')}>
          -10 Days
        </Button>
      )}

      <AntdRangePicker
        value={value}
        placeholder={['Date from', 'Date to']}
        className='h-9'
        size='middle'
        separator='-'
        format='MMM DD'
        suffixIcon={<Icon className='text-orange' path={mdiCalendarMonth} size={0.8} />}
        onChange={handleChange}
        {...datePickerProps}
      />

      {showExpandDays && (
        <Button size='middle' shape='round' onClick={() => adjustDateRange('add')}>
          +10 Days
        </Button>
      )}
    </Flex>
  );
};

export default RangePicker;
